/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@mui/material';

const SWITCH_CLASSES = {
  root: 'mui-switch-root',
  switchBase: 'mui-switch-switchBase',
  thumb: 'mui-switch-thumb',
  track: 'mui-switch-track'
};

const PearsonSwitch = forwardRef(({ classes, ...props }, ref) => (
  <Switch
    ref={ref}
    {...props}
    classes={{
      ...SWITCH_CLASSES,
      ...classes
    }}
  />
));

PearsonSwitch.displayName = 'PearsonSwitch';

PearsonSwitch.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    switchBase: PropTypes.string,
    thumb: PropTypes.string,
    track: PropTypes.string
  })
};

export default PearsonSwitch;
